import {trigger, transition, style, animate} from '@angular/animations';
import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'app/services/api.service';
import { SocketService } from 'app/services/socket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-passenger-video-view',
  templateUrl: './passenger-video-view.component.html',
  styleUrls: ['./passenger-video-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('1000ms ease-in', style({transform: 'translateY(0%)'}))
      ])
    ])
  ]
})
export class PassengerVideoViewComponent implements OnInit {
  @ViewChild('expansionPanel', {static: false}) expansionPanel: MatExpansionPanel;
  activeIndex = 0;
  overAllStatus = {
    'left_camera': true,
    'right_camera': true
  };
  shoppingExpand: boolean = false;
  etaExpand: boolean = false;
  boarding_msg = 'Boarding Started';
  gate_close = 0;
  // recallBoardingFlight: any = null;
  adClose: boolean = false;
  checkRolling: any = 'assets/images/checkrollingss.gif';
  childData: any = {};
  @Output() revertBack: EventEmitter<any> = new EventEmitter();
  videSrc: string = '';
  expand: boolean = true;
  scanCount: number = 0;
  spinner = false;
  adTimer: any;
  adSrc = '';
  adCounter: number = 1;
  countdowncount: number = 11;
  pc: RTCPeerConnection | null = null;
  videoContainer: HTMLVideoElement | null = null;
  restartTimeout: any = null;
  sessionUrl: any = '';
  queuedCandidates: any = [];
  offerData: any = null;
  streamUrl = 'https://stream.adr.avileap.com/webrtc/main/1037070/';
  timer: any = {s: 72000, mn: 0, hr: 0};
  mintimer: any = {s: 72000, mn: 0, hr: 0};
  mintimerHandler: any;
  showclose: boolean = false;
  thankingMsgCondition: boolean = false;
  thankingTimeCondition: boolean = false;
  thankYouMsg: string = 'Thank You!';
  flightData;
  flightNo: string;
  dataarray;
  data=[];
  camcahneg:boolean = true;
  callapi;
  imageFlightCode: boolean = true;
  engdis: boolean = true;
  ref: MatDialogRef<any>;
  @ViewChild("DialogComponent", { read: TemplateRef, static: false }) DialogComponent: TemplateRef<any>;
  datamessage = '';
  isPortrait: boolean;
  @Input() fromispotrait:boolean;
  @Input() paxsessionid:any;


  public config: SwiperConfigInterface = {
    slidesPerView: 'auto',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: true,
    pagination: false
  };
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  public type: string = 'component';

  public disabled: boolean = false;
  slider:boolean = false
  slides = [1, 2];
  currentIndex = 0; 
  direction: 'right' | 'left' ='right';

  
  constructor(private apiService: ApiService,public dialog: MatDialog, private socket: SocketService, private snackBar: MatSnackBar, public router: Router,private route: ActivatedRoute, private date: DatePipe) {
    this.data= [];
    this.route.queryParams.subscribe(params => {
      this.flightNo = params['gateno'].toUpperCase();
    });
    this.paxsessionid = this.apiService.getsessionId("sessionId");
  }



  

  public toggleSlidesPerView(): void {
    if (this.config.slidesPerView == 1) {
      this.config.slidesPerView = 1;
    } else {
      this.config.slidesPerView = 1;
    }
  }

  onIndexChange(event: any) {
    // Determine the direction based on the change in the active index
    this.currentIndex = event;
  }


  public onSwiperEvent(event: string): void {
  }
  
  @HostListener ('window:focus', ['$event'])
  onFocus (event: any): void {
    this.startPlaying();
  }

  
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
    // this.calldata();
  }

  ngOnInit() {
    this.childData = JSON.parse(JSON.stringify(this.childData));
    if(this.paxsessionid && !this.fromispotrait){
      const param = {
        pax_session_id: this.paxsessionid
      }
      if (window.performance.navigation.type == 1) {
        param['refresh'] = true;
      }
      this.apiService.verifyapi(param).subscribe(response=>{
        if(response){
          this.data = this.apiService.getSharedData();
          if(!this.data){
            this.calldata()
          }
          else if(this.data){
          this.callapisdata();
      }
        }
      },(error)=>{
        this.router.navigate(['']);
        history.pushState(null, '', '/');
          this.opendialog('Session token has expired');
      })
    }else if(!this.paxsessionid || this.fromispotrait){
      if(!this.paxsessionid){
        this.apiService.getsession(this.flightNo).subscribe(res=>{
          this.apiService.setsessionId('sessionId', res.id, 2);
          this.paxsessionid = res.id;
          const param = {
            pax_session_id: res.id
          }
          this.apiService.verifyapi(param).subscribe(res=>{
            this.data = this.apiService.getSharedData();
          if(!this.data){
            this.calldata()
          }else if(this.data){
              this.thankingMsgCondition = false;
              this.dataarray = this.data[0];
              this.callingBoardingFlight();
              this.startPlaying();
            }        
        },(error)=>{
          this.router.navigate(['']);
          history.pushState(null, '', '/');
          this.opendialog('Session token has expired');
        })    
      })
      }
      this.data = this.apiService.getSharedData();
      if(!this.data){
        this.calldata()
      }
      else if(this.data){
          this.callapisdata()
      }
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.adTimer) {
      clearInterval(this.adTimer);
    }
    this.etaExpand = false;
    this.boarding_msg = 'Boarding Started';
    this.gate_close = 0;
    this.adClose = false;
    this.spinner = false;
    this.adTimer;
    this.adSrc = '';
    this.adCounter = 1;
    this.countdowncount = 11;
    this.thanksImg = false;
    this.boardingStatus = false;
    this.countdownTimer = null;
    this.changeColor();

  }

  disclaimerclick(){
    this.engdis = !this.engdis
  }

  opendialog(message){
    this.datamessage = message;
    // this.dialogopen.opendialogbox(message)
    this.ref = this.dialog.open(this.DialogComponent);
  }

  calldata(){
      this.apiService.gates_api(this.flightNo).subscribe(response => {
        this.apiService.setSharedData(response.data);
        this.data = this.apiService.getSharedData();
        this.callapisdata();
      })
  }

  callapisdata(){
    this.thankingMsgCondition = false;
          this.dataarray = this.data[0];
          this.callingBoardingFlight();
          this.startPlaying();
          this.callapi = setInterval(() => {
            this.callingBoardingFlight()
          }, 30000);
  }

  closedialog(){
    this.ref.close();
  }

  admertisementclick(){
  //  window.open(
  //   "https://www.zestiot.com",
  //   "Independent Window",
  // );
}

checkOrientation(): void {
  const newIsPortrait = window.innerHeight > window.innerWidth;
  if (newIsPortrait !== this.isPortrait) {
    this.isPortrait = newIsPortrait;
    // this.showOrientationPopup();
  }
  this.paxsessionid = this.apiService.getsessionId('sessionId')
  if(this.isPortrait == true){
    this.childData.flight_code = '';
     this.calldata();
  }
}

  startPlaying() {
    if (!this.thankingMsgCondition) {
      const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
        embeddedPlayer.src = this.dataarray.front_camera;
      function toggleFullScreen() {
        if (!document.fullscreenElement) {
          if (embeddedPlayer.requestFullscreen) {
            embeddedPlayer.requestFullscreen().catch(err => {
              console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }

        // Add a click event listener to the iframe to toggle fullscreen
        embeddedPlayer.addEventListener("click", toggleFullScreen);

        // Set the aspect ratio to 16:9
        // embeddedPlayer.style.width = "100%";
        // embeddedPlayer.style.height = "56.25vw"; // 16:9 aspect ratio (9 / 16 * 100)
      }
    }
  }

  currentCameraIndex: number = 0;
  camclicked() {
    if(!this.thankingMsgCondition && this.dataarray.left_camera || !this.thankingMsgCondition && this.dataarray.right_camera){
    const cameraUrls: string[] = [this.dataarray.front_camera];
    if (this.dataarray.left_camera) {
      cameraUrls.push(this.dataarray.left_camera);
    }
    if (this.dataarray.right_camera) {
      cameraUrls.push(this.dataarray.right_camera);
    }
    const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
    if (embeddedPlayer) {
      this.currentCameraIndex = (this.currentCameraIndex + 1) % cameraUrls.length;
      embeddedPlayer.src = cameraUrls[this.currentCameraIndex];
      function toggleFullScreen() {
        if (!document.fullscreenElement) {
          if (embeddedPlayer.requestFullscreen) {
            embeddedPlayer.requestFullscreen().catch(err => {
              console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      }
  
      embeddedPlayer.addEventListener("click", toggleFullScreen);
  
      embeddedPlayer.style.width = "100%";
      embeddedPlayer.style.height = "56.25vw";
    } 
  }
  }  


  boardingtime;
  callingBoardingFlight() {
    if ((this.dataarray && this.dataarray.gate_no)) {
      this.apiService.adrInnerVideo({gate: this.dataarray.gate_no}).subscribe((res: any) => {
        if (res.data) {
          this.childData = {...this.childData, ...res.data} || {};
          if(this.childData.boarding_pts){
            this.boardingtime = new Date(this.childData.boarding_pts);
          }
          this.showclose = (this.childData.status == 'Boarding will start soon ' || this.childData.status == 'Gate not assigned to any flight ')? true : false;
          // this.openSnackBar(this.childData.status);
          this.revertTimer(!this.childData.flightnodep,this.boardingtime);
        }
      });
    }
  }

  navigateclick(){
    this.router.navigate(['/app/digital-twin'])
  }

  getLogoImage() {
    return this.childData.flight_code ? `assets/images/airlineLogos/${this.childData.flight_code}.png` : null;
  }
  onLoadFlightLoad(event: any) {
    this.imageFlightCode = false;
  }

  numberDigits(n: number) {
    return n > 9 ? '' + n : '0' + n;
  }

  revertTimer(data: boolean, btime: any = null) {
    if (data && btime) {
      setInterval(() => {
        this.timer.s -= 1;
        this.getDiffrence(btime);
        // if (this.timer.s < 0) {
        //   // this.timer.s = 59;
        //   // this.timer.mn = -1;
        //   this.onBack();
        // }
      }, 1000);
    }
    // this.mintimerHandler = setInterval(() => {
    //   this.mintimer.s -= 1;
    //   if (this.mintimer.s == 20) {
    //     this.thankingTimeCondition = true;
    //   }
    //   if (this.mintimer.s < 0) {
    //     // this.timer.s = 59;
    //     // this.timer.mn = -1;
    //     this.thankingTimeCondition = false;
    //     this.thankingMsgCondition = true;
    //     const aaa = document.getElementById('embedded-player') as HTMLIFrameElement;
    //     aaa.src = '';
    //     clearInterval(this.mintimerHandler);
    //   }
    // }, 1800);
  }

  getDiffrence(btime) {
    let dateNow: any = new Date(new Date().toLocaleString('en-US', {timeZone: '+0100'}))
    let dateFuture: any = new Date(btime.getFullYear() +1, 0, 1);

    let seconds = Math.floor((dateFuture - (dateNow))/1000);
    let minutes = Math.floor(seconds/60);
    let hours = Math.floor(minutes/60);
    let days = Math.floor(hours/24);

    hours = hours-(days*24);
    minutes = minutes-(days*24*60)-(hours*60);
    seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
    this.timer = {s: seconds, mn: minutes, hr: hours};
  }

  openSnackBar(message: string, action?: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snackbar-background'],
      duration: 2000,
    });
  }

  changeColor() {
    this.childData.video_url = this.childData.video_url === this.childData.left_camera ? this.childData.right_camera : this.childData.left_camera;
  }

  getCardStyles(index: number) {
    return {
      'background-color': this.activeIndex === index ? '#3BB9B9' : 'darkgray'
    };
  }

  boardingStatus: boolean = false;

  countdownTimer: any;
  thanksImg: boolean = false;

  showThankyouSlide() {
    this.thanksImg = true;
  }

  ngOnDestroy() {
    if (this.adTimer) {
      clearInterval(this.adTimer);
    }
    clearInterval(this.callapi);
  }

  refresh() {
    this.thankingMsgCondition = !this.thankingMsgCondition;
    this.camcahneg = !this.camcahneg;
    this.timer = {s: 72000, mn: 0, hr: 0};
    this.mintimer = {s: 72000, mn: 0, hr: 0};
    this.callingBoardingFlight();
    this.startPlaying();
    // window.location.reload();
  }

  onBack() {
    this.router.navigate(['/']);
  }
}
